(function() {
  var popupOverlay = document.getElementById('promo-popup-overlay');
  var closeBtn = document.getElementById('promo-popup-close');
  var toggleBtn = document.getElementById('promo-popup-toggle');
  var form = document.getElementById('promo-popup-form');
  var POPUP_COOKIE = 'promoPopupClosed';
  var TOGGLE_COOKIE = 'promoToggleClosedAt';
  var TIMEOUT = 10000;

  function setCookie(name,value,days) {
    var expires='';
    if(days){ var d=new Date(); d.setTime(d.getTime()+days*24*60*60*1000); expires='; expires='+d.toUTCString(); }
    document.cookie=name+'='+value+expires+'; path=/';
  }
  function getCookie(name) {
    var m=document.cookie.match('(^|;)\\s*'+name+'\\s*=\\s*([^;]+)'); return m?m.pop():null;
  }

  function showPopup() {
    hideToggleImmediate();
    popupOverlay.style.display='flex'; void popupOverlay.offsetWidth;
    popupOverlay.classList.add('showing'); popupOverlay.classList.remove('hiding');
  }
  function hidePopup() {
    popupOverlay.classList.remove('showing'); popupOverlay.classList.add('hiding');
    popupOverlay.addEventListener('animationend',function f(e){ if(e.animationName==='fadeOutScale'){
      popupOverlay.style.display='none'; popupOverlay.classList.remove('hiding'); initToggle(); }
      popupOverlay.removeEventListener('animationend',f);
    });
    setCookie(POPUP_COOKIE,'1',7);
  }
  function showToggle() {
    toggleBtn.style.display='block'; void toggleBtn.offsetWidth;
    toggleBtn.classList.add('showing'); toggleBtn.classList.remove('hiding');
  }
  function hideToggleImmediate() {
    toggleBtn.style.display='none'; toggleBtn.classList.remove('showing','hiding');
  }
  function initToggle() {
    var ts=getCookie(TOGGLE_COOKIE);
    if(ts){ if(Date.now()-parseInt(ts,10)>24*60*60*1000) showToggle(); }
    else showToggle();
  }

  document.addEventListener('DOMContentLoaded',function(){
    if(!getCookie(POPUP_COOKIE)) setTimeout(showPopup,TIMEOUT);
    else initToggle();
  });

  closeBtn.addEventListener('click',hidePopup);

  toggleBtn.addEventListener('click',function(e){
    if(e.target.id==='promo-toggle-close'){
      toggleBtn.classList.remove('showing'); toggleBtn.classList.add('hiding');
      toggleBtn.addEventListener('animationend',function g(){ hideToggleImmediate(); setCookie(TOGGLE_COOKIE,Date.now(),1); toggleBtn.removeEventListener('animationend',g); });
    } else {
      toggleBtn.classList.remove('showing'); toggleBtn.classList.add('hiding');
      toggleBtn.addEventListener('animationend',function h(){ toggleBtn.style.display='none'; showPopup(); toggleBtn.removeEventListener('animationend',h); });
    }
  });

  form.addEventListener('submit',function(e){ e.preventDefault(); hidePopup(); });
})();